<p-panel>
  <div class="d-flex align-content-center" [ngClass]="{'justify-content-between': this.activateREA, 'justify-content-left': !this.activateREA}">
    <div>
      <h4 *ngIf="flag === 'edit'">{{headerTitleWhenEdit}}</h4>
      <h4 *ngIf="flag === 'new'">{{headerTitleWhenNew}}</h4>
      <h5 *ngIf="this.appName !== 'gardengest'">Datos de {{fincaName}}</h5>
    </div>
    <div>
      <button 
        *ngIf="this.activateREA" 
        class="btn bg-warning bg-gradient mx-4 text-black" 
        id="export-rea" 
        (click)="showDialogExportREA = true"
        [disabled]="this.model.codigo_REA == null || this.model.codigo_REA == ''"
        > 
        <i class="fa fa-download"></i>
        Importar REA
      </button>
    </div>
  </div>
  <app-form-builder
    [model]="model"
    [undoEnabled]="false"
    [distributionColumns]="4"
    [fields]="formFields"
    (formChanges)="formChanges($event)">
  </app-form-builder>
  <br>
  <h5 *ngIf="this.appName !== 'gardengest'">Datos del titular</h5>
  <app-form-builder *ngIf="this.appName !== 'gardengest'"
    [model]="model"
    [undoEnabled]="undoEnabled"
    [distributionColumns]="3"
    [fields]="formFieldsTitular"
    (formChanges)="formChanges($event)">
  </app-form-builder>
  <br>
  <h5 *ngIf="this.appName !== 'gardengest' && this.activateREA">Datos del representante</h5>
  <app-form-builder *ngIf="this.appName !== 'gardengest' && this.activateREA"
    [model]="model"
    [undoEnabled]="undoEnabled"
    [distributionColumns]="3"
    [fields]="formFieldsRepresentante"
    (formChanges)="formChanges($event)">
  </app-form-builder>
  <br>
  <div class="d-flex justify-content-center">
    <div>
      <button class="btn btn-dark mx-2" (click)="goBack()">Volver</button>
    </div>
    <app-request-button
            [lockOnSuccess]="true"
            (click)="submit()"
            [error]="error"
            [mode]="requestButtonType"
            [request]="request">
    </app-request-button>
  </div>
</p-panel>

<p-dialog [(visible)]="showDialogExportREA" header="Importar REA" [style]="{width: '50vw'}" [modal]="true" [closable]="false" id="export-rea-dialog">
  <ng-template pTemplate="body">
    <div class="p-fluid">
      <div class="p-field p-col-12 p-md-6">
        <label for="input-text">Codigo REA</label> : {{ model.codigo_REA }}
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="input-text">NIF</label>:  {{ model.nif }}
      </div>
    </div>

    <div>
      <p-message class="mx-5" severity="info" *ngIf="historicoREA?.statusCode == 201">Nueva importacion </p-message>
      <p-message class="mx-5" severity="info" *ngIf="historicoREA?.statusCode == 200">Última importación: {{ historicoREA?.data.fecha }}</p-message>
    </div>

    <div class="d-flex justify-content-center align-content-center mx-5">
      <p-progress-spinner *ngIf="showSpinner" styleClass="p-component-overlay m-auto" strokeWidth="6" animationDuration="1.5s"></p-progress-spinner>
      <div class="w-100" *ngIf="importResult?.statusCode == 202">
        <p-card>
          <h4>Detalle de importación</h4>
          <hr>
          <p>Parcelas no insertadas: <b> {{ importResult?.data.parcelasNoInsertadas }} </b></p>
          <p>Parcelas insertadas: <b> {{ importResult?.data.parcelasInsertadas }} </b></p>
          <p>Parcelas no actualizadas: <b> {{ importResult?.data.parcelasNoActualizadas }} </b></p>
          <p>Parcelas actualizadas: <b> {{ importResult?.data.parcelasActualizadas }} </b></p>
        </p-card>
      </div>
    </div>

    <p-message class="mx-5" *ngIf="messageState == 'warning'" severity="warn" > Falta datos para exportar REA</p-message>
    <p-message class="mx-5" *ngIf="messageState == 'error'" severity="error" >{{ importResult?.statusMessage }}</p-message>
    <p-message class="mx-5" *ngIf="messageState == 'sucess'" severity="success" >{{ importResult?.statusMessage }}</p-message>

  </ng-template>

  <ng-template #footer>
    <div class="d-flex justify-content-center align-content-center gap-5 w-100">
      <button class="btn btn-dark mx-2" *ngIf="importResult?.statusCode" (click)="showDialogExportREA = false; showSpinner = false; messageState = '';showBtnConfirm = true">Volver</button>
      <button class="btn btn-dark bg-gradient" *ngIf="!importResult?.statusCode" (click)="showDialogExportREA = false; showSpinner = false; messageState = ''; showBtnConfirm = true"> Cancelar </button>
      <button class="btn btn-success bg-gradient" (click)="showSpinner = true; exportREA(model)" *ngIf="showBtnConfirm">Continuar</button>
    </div>  
  </ng-template>
</p-dialog>